
    import React from 'react'
    import Base from '@ucheba/ui/components/Icon'
    import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js"
    import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js"

    const symbol = new SpriteSymbol({
  "id": "icon__fb_circle",
  "use": "icon__fb_circle-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon__fb_circle\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12 0C5.373 0 0 5.373 0 12c0 6.016 4.432 10.984 10.206 11.852V15.18H7.237v-3.154h2.969V9.927c0-3.475 1.693-5 4.581-5 1.383 0 2.115.103 2.461.149v2.753h-1.97c-1.226 0-1.654 1.163-1.654 2.473v1.724h3.593l-.487 3.154h-3.106v8.697C19.481 23.083 24 18.075 24 12c0-6.627-5.373-12-12-12z\" /></symbol>"
})
    sprite.add(symbol)

    export default React.memo(function IconFbCircleIcon(props) {
      const { className, ...restProps } = props
      return <Base.Icon className={className} id="icon__fb_circle" {...restProps} />
    })
  